import { ref, watchEffect } from "vue";

// ── Detect system preference ──────────────────────────────────────────────────
const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)");

// ── Resolve initial value ─────────────────────────────────────────────────────
// Priority: localStorage → system preference
function getInitialTheme() {
	const saved = localStorage.getItem("trekko-theme");
	if (saved === "light") return true;
	if (saved === "dark") return false;
	// No saved preference — use system
	return !systemPrefersDark.matches; // isLight = true when system is light
}

const isLight = ref(getInitialTheme());

// ── Watch for system theme changes (only when user hasn't overridden) ─────────
systemPrefersDark.addEventListener("change", (e) => {
	if (!localStorage.getItem("trekko-theme")) {
		isLight.value = !e.matches;
	}
});

// ── Persist to localStorage whenever isLight changes ─────────────────────────
watchEffect(() => {
	localStorage.setItem("trekko-theme", isLight.value ? "light" : "dark");
});

// ── Composable ────────────────────────────────────────────────────────────────
export function useTheme() {
	function toggleMode() {
		isLight.value = !isLight.value;
	}

	function resetToSystem() {
		localStorage.removeItem("trekko-theme");
		isLight.value = !systemPrefersDark.matches;
	}

	return { isLight, toggleMode, resetToSystem };
}
